/* eslint-disable import/prefer-default-export */
import { createRoutine } from 'redux-saga-routines';

export const exportEntityList = createRoutine('EXPORT/ENTITY_LIST');
export const exportData = createRoutine('EXPORT/DATA');
export const exportEntityListRequest = createRoutine('EXPORT/ENTITY_LISTV2');
export const exportDataRequest = createRoutine('EXPORT/DATAV2');
